import React from 'react'
import { Link } from 'react-router-dom'
import { useContent } from '../../services'

const newsImages = {
  'news-1.jpg': require('../../assets/images/resource/news-1.jpg'),
  'news-2.jpg': require('../../assets/images/resource/news-2.jpg'),
  'news-3.jpg': require('../../assets/images/resource/news-3.jpg'),
};

function Recntupdates() {
  const { data: updates, loading } = useContent('homeRecentUpdates');

  if (loading || !updates) return null;

  return (
    <>
      <section className="news-section">
        <div className="auto-container">
          <div className="title-box centered">
            <div className="subtitle"><span>{updates.subtitle}</span></div>

            <div className="pattern-image">
              <img src={require('../../assets/images/icons/separator.svg').default} alt='mySvgImage' />
            </div>

            <h2> {updates.title} </h2>
          </div>

          <div className="row justify-content-center clearfix">
            {updates.items.map((item, index) => (
              <div key={item.id} className="news-block col-lg-4 col-md-6 col-sm-12">
                <div className="inner-box wow fadeInUp" data-wow-duration="1500ms" data-wow-delay={`${index * 300}ms`}>
                  <div className="image-box">
                    <div className="date"><span>{item.date}</span></div>
                    <div className="image"><Link to={item.link}><img src={newsImages[item.image]} alt="" /></Link></div>
                    <div className="over-content">
                      <div className="cat">{item.category}</div>
                      <h4><Link to={item.link}>{item.title}</Link></h4>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="lower-link-box text-center">
            <Link to={updates.cta.link} className="theme-btn btn-style-two clearfix">
              <span className="btn-wrap">
                <span className="text-one">{updates.cta.label}</span>
                <span className="text-two">{updates.cta.label}</span>
              </span>
            </Link>
          </div>
        </div>
      </section>
    </>
  )
}

export default Recntupdates
